import React from 'react';
import css from './Sections.module.css';
import featureImg1 from '../Images/land-finding-img1.png';
import featureImg2 from '../Images/land-finding-img2.png';
import featureImg3 from '../Images/land-finding-img3.png';
function FeatureSection() {
  return (
    <div className={css.featureSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.featureInfo}>
          <div className={css.featureBlock}>
            <div className={css.featureImg}>
              <img src={featureImg1} alt="" />
            </div>
            <h3>Ground Remediation</h3>
            <p>
              Identify trusted ground remediation experts to resolve site issues early, ensuring a
              safe, build-ready foundation.
            </p>
          </div>
          <div className={css.featureBlock}>
            <div className={css.featureImg}>
              <img src={featureImg2} alt="" />
            </div>
            <h3>Civil Construction</h3>
            <p>
              Connect with experienced civil construction contractors to deliver safe, efficient
              groundwork and infrastructure for your project.
            </p>
          </div>
          <div className={css.featureBlock}>
            <div className={css.featureImg}>
              <img src={featureImg3} alt="" />
            </div>
            <h3>Foundations</h3>
            <p>
              Find reliable foundation contractors to ensure your build starts strong, stable, and
              ready for vertical construction.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeatureSection;
